import { createElement } from 'react';
import { Card } from 'react-vant';
import { Button } from 'react-vant';
import './index.scss';
const HhContainer = ({ title, children, direction = 'column', style = {}, ...otherProps }) => {
    const _style = style || {};
    _style.flexDirection = direction;
    const _otherProps = otherProps || {};
    _otherProps.style = _style;
    return (createElement("div", null,
        createElement(Button, { type: "primary" }, "\u64CD\u4F5C"),
        createElement(Card, null,
            title && createElement(Card.Header, null, title),
            createElement(Card.Body, null,
                createElement("div", { className: 'container-wrapper', ..._otherProps }, children)))));
};
HhContainer.displayName = 'HhContainer';
export default HhContainer;
